module.exports = __webpack_public_path__ + "static/ibotta_gif-59ff31b908387deb1083398d22e61502.gif";